<template>
	<div>
		<Header :headerData="headerData" />
		<div class="content_spacer"></div>

		<!-- 查询区 -->
		<div class="query_box query-box-uniform">
			<!-- <a-select
				v-model:value="searchForm.file_category"
				:options="categoryOptions"
				allowClear
				class="query_input"
				:placeholder="t('tool.fileCategory')"
				@change="handleSearch"
			/> -->
			<a-select
				v-model:value="searchForm.status"
				:options="statusOptions"
				allowClear
				class="query_input"
				:placeholder="t('tool.status')"
				@change="handleSearch"
			/>
			<a-button type="primary" size="small" @click="handleSearch">
				<component :is="$antIcons['SearchOutlined']" style="margin-right: 5px;margin-top:-3px" />
				{{ t('base.search') }}
			</a-button>
		</div>

		<!-- 操作按钮 -->
		<div class="operate_btn">
			<a-button v-if="publishBtnAuth" type="primary" size="small" style="margin-right:10px;margin-bottom:10px" @click="handle('add')">
				<component :is="$antIcons['UploadOutlined']" style="margin-right: 5px;margin-top:-3px" />
				{{ t('base.upload') }}
			</a-button>
		</div>

		<!-- 列表 -->
		<Table
			ref="tableRef"
			class="table"
			:table="table"
			@handleChangePagination="handleChangePagination"
		>
			<template #customCol="{ props }">
				<template v-if="props.column.key === 'status'">
					{{ mapStatus(props.record.status) }}
				</template>
				<template v-else-if="props.column.key === 'file_category'">
					{{ mapCategory(props.record.file_category) }}
				</template>
			</template>

			<template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button type="primary" size="small" style="margin-right:10px" :disabled="!(props.record.file_category_val == 'service' && props.record.status_val == 0)" @click="handle('edit', props.record)">
						{{ t('base.edit') }}
					</a-button>
					<a-button type="primary" size="small" @click="handle('detail', props.record)">
						{{ t('base.detail') }}
					</a-button>
                </template>
            </template>
		</Table>

		<!-- 上传弹窗 -->
		<a-modal
			v-model:open="uploadVisible"
			:title="t('tool.upload')"
			:width="1020"
			centered
			:maskClosable="false"
			:confirmLoading="uploading"
			@ok="submit"
			@cancel="uploadVisible=false"
		>
			<div class="form_row" v-if="operateType !== 'edit'">
				<label class="form_label">{{ t('tool.category') }} <span class="form_label_required">*</span></label>
				<a-select v-model:value="uploadCategory" :options="categoryOptions" class="form_input" />
			</div>
			<div class="form_row" v-if="operateType !== 'edit'">
				<label class="form_label">{{ t('tool.file') }} <span class="form_label_required">*</span></label>
				<a-upload
					:file-list="appFileList"
					:before-upload="beforeUploadApp"
					accept=".yml,.exe,.blockmap,.json"
					multiple
					@remove="onRemoveApp"
				>
					<a-button size="middle" class="select-files-btn">{{ t('tool.selectFiles') }}</a-button>
				</a-upload>
			</div>

			<div v-if="uploadCategory === 'service' || operateType === 'edit'">
				<a-divider>{{ t('tool.versionUpdateContent') }}</a-divider>

				<div style="margin-top:20px">
					<label class="form_label">{{ t('tool.descriptionEn') }}</label>
					<a-button type="primary" size="small" style="margin-bottom:10px;margin-left:50px;padding:0 20px;" @click="addDescLine('en')">
						<plus-outlined />
					</a-button>
					<div 
						v-for="(item,index) in descrition_en" 
						:key="index" 
						style="display:block;margin-bottom:10px;margin-left:140px" 
					>
						<minus-circle-outlined class="deleteBtn" :class="{'deleteBtnDisabled': descrition_en.length === 1}" @click="deleteDescLine('en',index)"/>
						<a-input 
							:addon-before="item.num+'.'" 
							v-model:value="item.descrition"
							class="form_input" 
							style="display:inline-block; width:85%;margin-left:10px"
						/> 
					</div>
				</div>

				<div style="margin-top:20px">
					<label class="form_label">{{ t('tool.descriptionDe') }}</label>
					<a-button type="primary" size="small" style="margin-bottom:10px;margin-left:48px;padding:0 20px;" @click="addDescLine('de')">
						<plus-outlined />
					</a-button>
					<div 
						v-for="(item,index) in descrition_de" 
						:key="index" 
						style="display:block;margin-bottom:10px;margin-left:140px" 
					>
						<minus-circle-outlined class="deleteBtn" :class="{'deleteBtnDisabled': descrition_de.length === 1}" @click="deleteDescLine('de',index)"/>
						<a-input 
							:addon-before="item.num+'.'" 
							v-model:value="item.descrition"
							class="form_input" 
							style="display:inline-block; width:85%;margin-left:10px"
						/> 
					</div>
				</div>

				<div style="margin-top:20px">
					<label class="form_label">{{ t('tool.descriptionFr') }}</label>
					<a-button type="primary" size="small" style="margin-bottom:10px;margin-left:50px;padding:0 20px;" @click="addDescLine('fr')">
						<plus-outlined />
					</a-button>
					<div 
						v-for="(item,index) in descrition_fr" 
						:key="index" 
						style="display:block;margin-bottom:10px;margin-left:140px" 
					>
					<minus-circle-outlined class="deleteBtn" :class="{'deleteBtnDisabled': descrition_fr.length === 1}" @click="deleteDescLine('fr',index)"/>
						<a-input 
							:addon-before="item.num+'.'" 
							v-model:value="item.descrition"
							class="form_input" 
							style="display:inline-block; width:85%;margin-left:10px"
						/> 
					</div>
				</div>
			</div>
			
		</a-modal>

		<!-- 详情 -->
		<a-drawer
			v-model:visible="detailVisible"
			class="custom-class"
			:title="t('base.detail')"
			placement="right"
			width="60%"
			@after-visible-change="handleDrawer"
		>
			<div class="desc_row">
				<a-divider orientation="left" >{{ t('tool.descriptionEn') }}</a-divider>
				<div v-for="(item,index) in detail_description_en" :key="index" class="desc_item">
					{{ index + 1 }}. {{ item }}
				</div>
				<a-empty v-if="detail_description_en.length === 0"/>
			</div>
			<div class="desc_row">
				<a-divider orientation="left">{{ t('tool.descriptionDe') }}</a-divider>
				<div v-for="(item,index) in detail_description_de" :key="index" class="desc_item">
					{{ index + 1 }}. {{ item }}
				</div>
				<a-empty v-if="detail_description_en.length === 0"/>
			</div>
			<div class="desc_row"> 
				<a-divider orientation="left">{{ t('tool.descriptionFr') }}</a-divider>
				<div v-for="(item,index) in detail_description_fr" :key="index" class="desc_item">
					{{ index + 1 }}. {{ item }}
				</div>
				<a-empty v-if="detail_description_en.length === 0"/>
			</div>
		</a-drawer>
	</div>
</template>

<script setup>
	import { ref, reactive, onMounted, computed } from 'vue';
	import Header from "@/layouts/component/Header.vue";
	import { getWeek } from '@/hooks/useGetWeek';
	import { useI18n } from 'vue-i18n';
	import Table from '@/components/Table.vue';
	import { ToolApi } from '@/api/ToolApi.js';
	import { message } from 'ant-design-vue';
	import { multiply, add, subtract, divide } from 'accurate-core';
	import { timestampToDate } from '@/utils/global';

	defineOptions({ name: 'ToolPublishManagement' })
	const { t } = useI18n();

	const headerData = ref({
		menu: 'menu.toolPublishManagement',
		menu_desc: 'menu.subToolPublishManagement',
		week: getWeek().week,
		current_time: getWeek().currentDate,
	});

	const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
	const tableRef = ref(null)
	const operateType = ref('')
	const rowData = ref({})
	const uploadVisible = ref(false)
	const detailVisible = ref(false)
	const uploading = ref(false)
	const appFileList = ref([])
	const uploadCategory = ref('service')
	const detail_description_en = ref([])
	const detail_description_de = ref([])
	const detail_description_fr = ref([])
	const descrition_en = ref([{num:1,descrition:''}])
	const descrition_de = ref([{num:1,descrition:''}])
	const descrition_fr = ref([{num:1,descrition:''}])
	const categoryOptions = [
		{ label: t('tool.service'), value: 'service' },
		// { label: t('tool.app'), value: 'app' },
	]
	const statusOptions = [
		{ label: t('tool.activated'), value: 0 },
		{ label: t('tool.unactivated'), value: 1 },
	]
	const searchForm = reactive({
		// file_category: null,
		status: null,
	})

	const table = ref({
		data: [],
		columns: [
			{ 
				title: t('tool.fileName'), 
				dataIndex: 'file_name', 
				key: 'file_name', 
				width: 200, 
				fixed: 'left', 
				ellipsis: false, 
				resizable: true,
				// customCell: (_, index) => {
				// 	if (index === 0) {
				// 		return { rowSpan: 3 };
				// 	}
				// 	if (index === 1) {
				// 		return { rowSpan: 0 };
				// 	}
				// 	if (index === 2) {
				// 		return { rowSpan: 0 };
				// 	}
				// } 
			},
			{ 
				title: t('tool.fileNo'), 
				dataIndex: 'file_no', 
				key: 'file_no', 
				width: 180, 
				resizable: true,
			},
			{ 
				title: t('tool.fileSize'), 
				dataIndex: 'file_size', 
				key: 'file_size', 
				width: 120, 
				resizable: true,
			},
			{ 
				title: t('tool.fileCategory'), 
				dataIndex: 'file_category', 
				key: 'file_category', 
				width: 120, 
				resizable: true 
			},
			{ 
				title: t('tool.status'), 
				dataIndex: 'status', 
				key: 'status', 
				width: 120, 
				resizable: true 
			},
			{ 
				title: t('tool.createTime'), 
				dataIndex: 'create_timestamp', 
				key: 'create_timestamp', 
				width: 160, 
				resizable: true 
			},
			{ 
				title: t('tool.downloadPath'), 
				dataIndex: 'download_path', 
				key: 'download_path', 
				width: 350, 
				ellipsis: false, 
				resizable: true 
			},
			{
                title: t('base.operate'),//'操作'
                key: 'action',
                fixed: 'right',
                width: 160,
				customCell: (row, index) => {
					// console.log(operationRowSpanConfig.value,'operationRowSpanConfig')
					return operationRowSpanConfig.value[index];
				} 
            },
		],
		configs: {
			table: {
				rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null)
			},
			scroll: {
				x: 1600,
				y: 400,
			},
			rowSelection: false,
			loading: false,
			pagination: {
				current: 1,
				pageSize: 10,
				total: 0,
				position: ['bottomLeft'],
				showSizeChanger: true,
				pageSizeOptions: ['10','20','50'],
			},
			operateBtn: {
				showSearch: false,
				showAdd: false,
			}
		}
	})

	
	const publishBtnAuth = computed(()=>{
		console.log(userInfo.value.id == 8517 || userInfo.value.id == 861,'当前登录人id', userInfo.value.id)
		return userInfo.value.id == 8517 || userInfo.value.id == 861
		// return import.meta.env.PROD? userInfo.value.role.split(',').includes('38') : userInfo.value.id == 861
	})

	// 计算操作列的合并配置（核心函数）
	const getOperationRowSpanConfig = (data) => {
		// 1. 统计每个时间戳出现的次数
		const timestampCount = {};
		data.forEach(item => {
			if(item.create_timestamp !== '-'){
				const ts = item.create_timestamp;
				timestampCount[ts] = (timestampCount[ts] || 0) + 1;
			}
		});

		// 2. 记录每个时间戳已分配的行数，生成合并配置
		const usedCount = {};
		return data.map(item => {
			if(item.create_timestamp !== '-'){
				const ts = item.create_timestamp;
				if (!usedCount[ts]) usedCount[ts] = 0;

				if (usedCount[ts] === 0) {
					// 首次出现：设置合并行数
					usedCount[ts]++;
					return { rowSpan: timestampCount[ts] };
				} else {
					// 非首次出现：隐藏单元格（rowSpan=0）
					usedCount[ts]++;
					return { rowSpan: 0 };
				}
			}
		})
	};

	const operationRowSpanConfig = computed(() => {
		return getOperationRowSpanConfig(table.value.data);
	});



	const handle = (type, record) => {
		switch(type){
			case'add':
				uploadVisible.value = true
				operateType.value = ''
				uploadCategory.value = 'service'
				appFileList.value = []
				descrition_en.value = [{num:1,descrition:''}]
				descrition_de.value = [{num:1,descrition:''}]
				descrition_fr.value = [{num:1,descrition:''}]
				break
			case 'edit':
				uploadVisible.value = true
				operateType.value = 'edit'
				rowData.value = record
				descrition_en.value = record.file_desc.split('**').map((item,index) => {
					return {
						num:index + 1,
						descrition:item
					}
				})
				descrition_de.value = record.file_desc_de.split('**').map((item,index) => {
					return {
						num:index + 1,
						descrition:item
					}
				})
				descrition_fr.value = record.file_desc_fr.split('**').map((item,index) => {
					return {
						num:index + 1,
						descrition:item
					}
				})
				break
			case 'detail':
				detailVisible.value = true
				detail_description_en.value = record.file_desc.split('**')
				detail_description_de.value = record.file_desc_de.split('**')
				detail_description_fr.value = record.file_desc_fr.split('**')
				break
		}
	}

	const normalizeStatus = (val) => {
		if (val === 0 || val === '0') return 0
		if (val === 1 || val === '1') return 1
		return val
	}

	const mapStatus = (val) => {
		const n = normalizeStatus(val)
		if (n === 0) return t('tool.activated')
		if (n === 1) return t('tool.unactivated')
		return formatCell(val)
	}

	const normalizeCategory = (val) => {
		const s = String(val ?? '').toLowerCase()
		if (s === 'app') return 'app'
		if (s === 'service') return 'service'
		return val
	}
	const mapCategory = (val) => {
		const c = normalizeCategory(val)
		if (c === 'app') return t('tool.app')
		if (c === 'service') return t('tool.service')
		return formatCell(val)
	}

	const formatCell = (val) => {
		if (val === undefined || val === null) return '-';
		const s = String(val);
		if (s.trim() === '') return '-';
		return s;
	};

	const handleDrawer = (visible) => {
		if(!visible){
			detail_description_en.value = []
			detail_description_de.value = []
			detail_description_fr.value = []
		}
	}

	const getList = async () => {
		table.value.configs.loading = true;
		const page_num = table.value.configs.pagination.current;
		const page_size = table.value.configs.pagination.pageSize;
		const param = {
			file_category: 'service', //searchForm.file_category,
			status: searchForm.status,
		};
		const res = await ToolApi.getInstance().getToolFileList(param, page_num, page_size)
		if (res.code === 0) {
			res.data.records.length > 0 && res.data.records.forEach((item, index) => {
				item.file_size = item.file_size == undefined? '-' : divide(divide(item.file_size, 1024), 1024).toFixed(4) + ' M'
				item.create_timestamp_val = item.create_timestamp
				item.create_timestamp = item.create_timestamp == undefined? '-' : timestampToDate(item.create_timestamp * 1000)
				item.latest_path = item.latest_path == undefined? '-' : item.latest_path
				item.status_val = item.status
				item.file_category_val = item.file_category
			})
			table.value.data = res.data.records
			table.value.configs.pagination.total = res.data.total
			table.value.configs.loading = false
		} else {
        	message.error(res.msg || t('base.getDataFail'));
		}
	}

	const handleSearch = () => {
		table.value.configs.pagination.current = 1;
		getList();
	};

	const handleChangePagination = (config) => {
		table.value.configs.pagination.current = config.current;
		table.value.configs.pagination.pageSize = config.pageSize;
		getList();
	};

	

	const beforeUploadApp = (file) => {
		appFileList.value = [...appFileList.value, file]
		return false
	}
	const onRemoveApp = (file) => {
		appFileList.value = appFileList.value.filter(f => f.uid !== file.uid)
	}

	const addDescLine = (type) => {
		let descrition_data = type == 'en' ? descrition_en.value : type == 'de' ? descrition_de.value : descrition_fr.value
		descrition_data.push({
			num:descrition_data.length + 1,
			descrition:''
		})
	}

	const deleteDescLine = (type,index) => {
		let descrition_data = type == 'en' ? descrition_en.value : type == 'de' ? descrition_de.value : descrition_fr.value
		if(descrition_data.length === 1) return

		descrition_data.splice(index,1)
		descrition_data.forEach((item,index) => {
			item.num = index + 1
		})
	}

	const submit = async () => {
		if(operateType.value === ''){
			if (!appFileList.value.length) {
				message.error(t('tool.filesCannotBeEmpty'))
				return
			}
			const form = new FormData()
			appFileList.value.forEach(f => form.append('file', f))
			uploading.value = true
			const hide = message.loading(t('base.uploading'), 0)
			try{
				let res
				if (uploadCategory.value === 'service') {
					form.set('category', 'service')
					form.set('file_desc', descrition_en.value.map(item => item.descrition).join('**'))
					form.set('file_desc_de', descrition_de.value.map(item => item.descrition).join('**'))
					form.set('file_desc_fr', descrition_fr.value.map(item => item.descrition).join('**'))
					res = await ToolApi.getInstance().uploadService(form)
				} else {
					form.set('category', 'app')
					res = await ToolApi.getInstance().uploadApp(form)
				}
				if (res && res.code === 0) {
					message.success(t('base.uploadSuccess'))
					uploadVisible.value = false
					getList()
				} else {
					message.error((res && (res.msg || res.message)) || t('base.operateFail'))
				}
			} catch(e){
				message.error(t('base.operateFail'))
			} finally {
				hide()
				uploading.value = false
			}
		}else{
			for(let i = 0; i < descrition_en.value.length; i++){
				let item = descrition_en.value[i]
				if(item.descrition === ''){
					message.error(t('tool.descriptionEn') + ' ' + t('base.noEmpty'))
					return
				}
			}
			for(let i = 0; i < descrition_de.value.length; i++){
				let item = descrition_de.value[i]
				if(item.descrition === ''){
					message.error(t('tool.descriptionDe') + ' ' + t('base.noEmpty'))
					return
				}
			}
			for(let i = 0; i < descrition_fr.value.length; i++){
				let item = descrition_fr.value[i]
				if(item.descrition === ''){
					message.error(t('tool.descriptionFr') + ' ' + t('base.noEmpty'))
					return
				}
			}

			let param = {
				id: rowData.value.id,
				file_desc: descrition_en.value.map(item => item.descrition).join('**'),
				file_desc_de: descrition_de.value.map(item => item.descrition).join('**'),
				file_desc_fr: descrition_fr.value.map(item => item.descrition).join('**'),
			}
			let res = await ToolApi.getInstance().editVersionContent(param)
			if(res.code === 0){
				message.success(t('base.editSuccessMsg'))
				uploadVisible.value = false
				getList()
			}else{
				message.error((res && (res.msg || res.message)) || t('base.operateFail'))
			}
		}
	}


	onMounted(() => {
		getList();
	})
</script>

<style lang="scss" scoped>
.content_spacer{
	height: 30px;
}

.query_box {
	margin: 20px 0 10px 0;
}
.operate_btn {
	margin-bottom: 10px;
}
.query-box-uniform {
	display: flex;
	align-items: center;
	gap: 16px;
	margin: 20px 0 18px 0;
}
.query_input {
	width: 200px;
}

.form_row {
	display: flex;
	align-items: center;
	margin-bottom: 12px;
}
.form_row:first-of-type{
	margin-top: 20px;
}
.form_row + .form_row{
	margin-top: 18px;
}
.form_label {
	width: 140px;
	color: #333;
}
.form_input {
	flex: 1;
}
.select-files-btn{
	min-width: 50px;
}
.form_label_required{
	color:red;
}
.deleteBtn{
	display:inline-block;
	margin-top:7px;
	font-size:15px;
	color:#0e5cad;
	cursor:pointer
}
.deleteBtnDisabled{
	cursor:not-allowed;
	color:#999;
}
.desc_row{
	margin-bottom: 60px;

	.desc_item{
		padding-left: 50px;
	}
}

::v-deep .page_header .week{
    margin-top: -55px;
    transform: translateY(8px);
}
::v-deep .page_header .admin_email{
    margin-top: -55px;
    transform: translateY(18px);
}

/* Compact table row height - align with Upgrade Rules */
::v-deep .ant-table-wrapper .ant-table-thead>tr>th,
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td,
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

// 当sub不为空时
// ::v-deep .page_header .week{
//     margin-top: -70px;
// }
// ::v-deep .page_header .admin_email{
//     margin-top: -60px;
// }
</style>

